import megamenu from 'components/megamenu'

const header = {
  init() {
    const logos = document.querySelectorAll<HTMLAnchorElement>('.header-logo')

    logos.forEach((logo) => {
      logo.removeEventListener('click', this.onClick.bind(this))
      logo.addEventListener('click', this.onClick.bind(this))
    })
  },
  onClick(e) {
    e.stopImmediatePropagation()
    // Select all navigation links
    const links = document.querySelectorAll<HTMLAnchorElement>('.navigation__link')

    // Remove .active from any currently active link
    links.forEach((link) => link.classList.remove('navigation-active'))
    megamenu.close()
    e.stopPropagation()
  },
}

export default header
